<app-password-update
  [user]="user"
  [modal]="true"
  (closeModal)="ref.close($event)"
/>
